export default {"src":"/_next/static/media/carOutline100_24.5bd08be5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};